import React, { lazy } from 'react';
import { SunIcon, SmileIcon, FeatherIcon, BrainIcon, MapIcon, CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const TRANS_IMG = 'https://cdn.magicpatterns.com/uploads/1Qu9V7GZP1i1FTfbe1MRkR/transformacion.webp';
const wins = [{
  icon: SunIcon,
  text: 'Despertar con energía real cada mañana'
}, {
  icon: SmileIcon,
  text: 'Verte al espejo y reconocerte'
}, {
  icon: FeatherIcon,
  text: 'Sentirte liviana y desinflamada'
}, {
  icon: BrainIcon,
  text: 'Tener claridad mental y buen humor'
}, {
  icon: MapIcon,
  text: 'Saber exactamente qué hacer cada día'
}];
export function TransformationSection() {
  return <section className="w-full bg-crema py-20 sm:py-28" data-id="element-169" data-mp="2994apzk3y20c">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16" data-id="element-170" data-mp="2968f4hvqfpf2">
        <div data-id="element-171" data-mp="207d3urdtzp4w">
          <Reveal data-id="element-172" data-mp="206v1re4hmgp2">
            <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-173" data-mp="208fvj1iz9vlv">
              Imagina en 30 días...
            </h2>
          </Reveal>

          <ul className="mt-8 space-y-4" data-id="element-174" data-mp="k1iyaus47n24">
            {wins.map((w, i) => <Reveal as="li" key={w.text} delay={i * 0.08} data-id="element-175" data-mp="k3lyg7mzewkk" data-mpi={i}>
                <div className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-sm sm:p-5" data-id="element-176" data-mp="5e7jmk0mzmxs">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-dorado/15 text-dorado" data-id="element-177" data-mp="acr74ouvp6s9">
                    <w.icon className="h-5 w-5" strokeWidth={1.7} data-id="element-178" data-mp="xzhco06frjhm" />
                  </span>
                  <span className="flex-1 text-base leading-snug text-tinta/90 sm:text-lg" data-id="element-179" data-mp="12ykfrf2uvfmy">
                    {w.text}
                  </span>
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-rosa-light/55" aria-hidden="true" data-id="element-180" data-mp="t1xtcluvsgit">
                    <CheckIcon className="h-4 w-4 text-rosa-dark" strokeWidth={2.6} data-id="element-181" data-mp="3dt7tryzx8ax8" />
                  </span>
                </div>
              </Reveal>)}
          </ul>

          <Reveal delay={0.2} data-id="element-182" data-mp="1fbo5q2vo7d6v">
            <p className="mt-8 text-lg leading-relaxed text-tinta/70" data-id="element-183" data-mp="1ak637ae014js">
              El cambio no llega de golpe. Llega en pequeños gestos diarios que,
              sumados, te devuelven a ti misma.
            </p>
          </Reveal>
        </div>

        <Reveal data-id="element-184" data-mp="11k992t8ubdhc">
          <div className="overflow-hidden rounded-3xl shadow-xl shadow-rosa/15" data-id="element-185" data-mp="11kstcglyqdyj">
            <img src={TRANS_IMG} alt="Mujer radiante con vestido blanco de brazos abiertos en un campo de flores al atardecer" className="h-full max-h-[600px] w-full object-cover" loading="lazy" data-id="element-186" data-mp="wjlnwo7alqv1" />
          </div>
        </Reveal>
      </div>
    </section>;
}